/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, November 27th 2021, 7:52:50 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

type ILogger = Partial<Console>;

const productionLogger = (): ILogger => ({
  info(message: string, ...optionalParams: any[]): void {},
  warn(message: string, ...optionalParams: any[]): void {
    console.warn(message, ...optionalParams);
  },
  error(message: string, ...optionalParams: any[]): void {
    console.error(message, ...optionalParams);
  },
  debug(message: string, ...optionalParams: any[]): void {},
});

const developmentLogger = (): ILogger => ({
  info(message: string, ...optionalParams: any[]): void {
    console.info(message, ...optionalParams);
  },
  warn(message: string, ...optionalParams: any[]): void {
    console.warn(message, ...optionalParams);
  },
  error(message: string, ...optionalParams: any[]): void {
    console.error(message, ...optionalParams);
  },
  debug(message: string, ...optionalParams: any[]): void {
    console.debug(message, ...optionalParams);
  },
});

const createLogger = (): ILogger => {
  if (process.env.NODE_ENV === "production") {
    return productionLogger();
  } else {
    return developmentLogger();
  }
};

export const logger = createLogger();
